import { isEqual } from "lodash"

// The drilldown panel's own "group contributors by X" selection must reset whenever the panel
// refocuses onto a different segment — but the reset target is "no grouping selected", never the
// segment itself. `resetKey` exists purely to detect a refocus; it is never a valid group-by value.
// Real callers (GroupingMenu / getAllAvailableRollups) pass a full rollup object
// ({isClassification|isTag|isPositionAttribute, id, label}) or null — never a bare string.
export interface GroupByOption {
  id: string
  label: string
  isClassification?: boolean
  isTag?: boolean
  isPositionAttribute?: boolean
  classificationId?: string
  proprietary?: boolean
  disabled?: boolean
  disabledTooltip?: string
}

export interface GroupBySelectionState {
  resetKey: unknown
  selection: GroupByOption | null
}

export function resolveGroupBySelection(currentSegment: unknown, state: GroupBySelectionState): GroupByOption | null {
  const hasRefocused = !isEqual(currentSegment, state.resetKey)
  return hasRefocused ? null : state.selection
}
